import { AnyAction } from 'redux'

const haltsInitialState: any = {
  data: null,
  error: false,
  fetching: false,
}

export const halts = (state = haltsInitialState, action: AnyAction) => {
  switch (action.type) {
    case 'PLANTANALYSIS_HALTS_IS_FETCHING':
      return {
        ...state,
        data: null,
        fetching: true,
        error: false,
      }
    case 'PLANTANALYSIS_HALTS_FETCH_SUCCESS':
      return {
        ...state,
        data: action.payload,
        fetching: false,
        error: false,
      }
    case 'PLANTANALYSIS_HALTS_FETCH_ERROR':
      return {
        ...state,
        fetching: false,
        error: true,
      }

    default:
      return state
  }
}

export default halts
